import { BusinessPartnersApi, Configuration } from "../../generated-client";
import "reflect-metadata";

export class BusinessPartnerClient {
	public businessPartnersApi: BusinessPartnersApi;

	constructor() {
		const basePath =
			window.BACKEND_URL || location.origin || "http://localhost:3000";
		const config = new Configuration({
			basePath: basePath,
			accessToken: () => sessionStorage.getItem("jwt") || "",
		});
		this.businessPartnersApi = new BusinessPartnersApi(config);
	}
}
